module.exports = __webpack_public_path__ + "static/media/eighteenth_friendship_way.158e225c.mp4";